// Lazy-load @sentry/browser (~0.5 MB) — light pages only report on rare error paths.
export const captureMessageLazily = (getMessage: () => string) => {
    import('@rwc/utils/sentry-error-reporter')
        .then(({ default: SentryErrorReporter }) => {
            SentryErrorReporter?.captureMessage(getMessage());
        })
        .catch(() => {
            // error reporting is best-effort; never break the page over it
        });
};
